import type { Config } from "@wagmi/core"
import type { Address } from "viem"
import { useQuery } from "@tanstack/react-query"

import type { Token } from "@/domains/core"
import type { CreateLockLensResult } from "@/domains/on-chain"
import { createLockLens, createLockLensDefaultValue } from "@/domains/on-chain"

type UseCreateLockLensProps = {
  account: Address
  governanceToken: Token
  vestedToken: Token
  chainId: number
  config: Config
  refetchInterval?: number
}

export const useCreateLockLens = ({
  account,
  chainId,
  config,
  governanceToken,
  vestedToken,
}: UseCreateLockLensProps): { createLockLens: CreateLockLensResult; refetchCreateLockLens: () => void } => {
  const { data, refetch } = useQuery<CreateLockLensResult>({
    queryKey: ["create-lock-lens", account],
    queryFn: async (): Promise<CreateLockLensResult> => {
      try {
        const lens = await createLockLens({
          account,
          chainId,
          config,
          governanceToken,
          vestedToken,
        })

        return lens
      } catch (error) {
        console.log("error", error)
        return createLockLensDefaultValue
      }
    },
    enabled: !!account,
    initialData: createLockLensDefaultValue,
  })

  return { createLockLens: data, refetchCreateLockLens: refetch }
}
